import { actionTypes } from "../../actions/action_types";

const initialState = {
  ranking: "",
  salesAverage: "",
  salesActive: "",
  salesExpired: "",
  inventoryTarget: "",
  branchCategory: "",
  packages: " ",
  customerProfiling: "",
  unredeemedPawns: "",
};

export default function chart_title_reducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.CHART_TITLE_SET_TITLES:
      stateCopy.ranking = action.payload.ranking;
      stateCopy.salesAverage = action.payload.salesAverage;
      stateCopy.salesActive = action.payload.salesActive;
      stateCopy.salesExpired = action.payload.salesExpired;
      stateCopy.inventoryTarget = action.payload.inventoryTarget;
      stateCopy.branchCategory = action.payload.branchCategory;
      stateCopy.packages = action.payload.packages;
      stateCopy.customerProfiling = action.payload.customerProfiling;
      stateCopy.unredeemedPawns = action.payload.unredeemedPawns;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_BRANCH_CATEGORIES:
      stateCopy.branchCategory = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_CUSTOMER_PROFILING:
      stateCopy.customerProfiling = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_INVENTORY_TARGET:
      stateCopy.inventoryTarget = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_PACKAGES:
      stateCopy.packages = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_RANKING:
      stateCopy.ranking = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_SALES_ACTIVE:
      stateCopy.salesActive = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_SALES_AVERAGE:
      stateCopy.salesAverage = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_SALES_EXPIRED:
      stateCopy.salesExpired = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_SET_UNREDEEMED_PAWN:
      stateCopy.unredeemedPawns = action.payload;
      return stateCopy;

    case actionTypes.CHART_TITLE_CLEAR_TITLES:
      stateCopy.ranking = null;
      stateCopy.salesAverage = null;
      stateCopy.salesActive = null;
      stateCopy.salesExpired = null;
      stateCopy.inventoryTarget = null;
      stateCopy.branchCategory = null;
      stateCopy.packages = null;
      stateCopy.customerProfiling = null;
      stateCopy.unredeemedPawns = null;
      return stateCopy;

    default:
      return state;
  }
}
